'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _buttonTextSubmit = require('common/components/button-text-submit');

var _buttonTextSubmit2 = _interopRequireDefault(_buttonTextSubmit);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var HomePageManualSignup = _react2['default'].createClass({
    displayName: 'HomePageManualSignup',


    propTypes: {
        'redirectUrl': _react2['default'].PropTypes.string,
        'initialErrorMessage': _react2['default'].PropTypes.string,
        'initialValue': _react2['default'].PropTypes.string,
        'utmCampaign': _react2['default'].PropTypes.string,
        'utmMedium': _react2['default'].PropTypes.string,
        'utmSource': _react2['default'].PropTypes.string,
        'utmTerm': _react2['default'].PropTypes.string,
        'campaignCode': _react2['default'].PropTypes.string,
        'onOptInChange': _react2['default'].PropTypes.func,
        'tabOffset': _react2['default'].PropTypes.number,
        'targetUrl': _react2['default'].PropTypes.string,
        'signupForm': _react2['default'].PropTypes.object.isRequired // Serialized sfForm
    },

    render: function render() {

        var targetUrl = this.props.targetUrl || '/account/signUp';
        var tabOffset = parseInt(this.props.tabOffset || 0, 10);

        var formData = {
            'signup[redirect_url]': this.props.redirectUrl,
            'signup[pending_tsm_group_guid]': this.props.pendingTsmGroupGuid, // for if the user sends a TsmGroup after they've gotten logged out somehow
            'signup[utm_campaign]': this.props.utmCampaign,
            'signup[utm_medium]': this.props.utmMedium,
            'signup[utm_source]': this.props.utmSource,
            'signup[utm_term]': this.props.utmTerm,
            'signup[campaign_code]': this.props.campaignCode,
            'signup[coupon_code]': '',
            'signup[billing_plan_quota_short_guid]': '',
            'signup[billing_period]': '',
            'signup[first_name]': '',
            'signup[last_name]': '',
            'signup[is_from_external]': '',
            'should_show_password': '0'
        };

        var validate = function validate(val) {
            if (!_hfReactHelper2['default'].isValidEmailAddress(val)) {
                return 'The email address that you\'ve entered is invalid. Please try again.';
            } else {
                return false;
            }
        };

        var actionBtn = _react2['default'].createElement(_button2['default'], {
            buttonText: 'SIGN UP FREE',
            buttonClass: 'm-login-or-signup--sign-up-button',
            buttonColor: 'cerulean',
            buttonTabIndex: tabOffset + 1 });

        // FIXME: too hardcoded to signup[] for my taste
        // FIXME: There's lot of things that could be refactored in here to make better use of BaseForm
        return _react2['default'].createElement(
            _buttonTextSubmit2['default'],
            {
                formName: 'newaccount',
                textPlaceholder: 'Email',
                textClass: 'm-login-or-signup--text-field',
                inputName: 'signup[email_address]',
                additionalFormData: formData,
                validate: validate,
                divClass: 'm-sign-mobile--send',
                url: targetUrl,
                initialValue: this.props.initialValue,
                actionButton: actionBtn,
                initialErrorMessage: this.props.initialErrorMessage,
                errorClass: 'c-warm-chinchilla',
                tabOffset: tabOffset,
                namespace: this.props.signupForm.namespace,
                fields: this.props.signupForm.fields,
                values: this.props.signupForm.values },
            _react2['default'].createElement('br', null),
            _react2['default'].createElement('input', { id: 'homepage_opt_in',
                type: 'checkbox',
                name: 'signup[is_opted_in_marketing_emails]',
                value: '1',
                defaultChecked: true,
                onChange: this.props.onOptInChange,
                tabIndex: tabOffset + 2 }),
            _react2['default'].createElement(
                'label',
                { htmlFor: 'homepage_opt_in', className: 'm-login-or-signup--opt-in-label' },
                'Send me HelloSign updates'
            )
        );
    }

    //FIXME: 'Send me HelloSign updates' should be a constant since it is used elsewhere

});

module.exports = HomePageManualSignup;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/home/manual-signup.jsx
 ** module id = 1025
 ** module chunks = 0
 **/